import React, { useContext } from 'react';
import { Box, SxProps, useTheme } from '@mui/material';
import { UiContext } from 'uiContext';

export default function RoundedContainer({
  roundSide,
  children,
  radius,
  sx,
}: {
  roundSide: 'left' | 'right';
  children: React.ReactNode;
  radius?: string;
  sx?: SxProps;
}) {
  const theme = useTheme();

  let borderRadius;
  if (radius) {
    borderRadius = radius;
  } else {
    borderRadius = theme.shape.borderRadius;
  }
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const roundSx =
    roundSide === 'left'
      ? {
          borderTopLeftRadius: borderRadius,
          borderBottomLeftRadius: borderRadius,
        }
      : {
          borderTopRightRadius: borderRadius,
          borderBottomRightRadius: borderRadius,
        };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: sp.s25,
        ...roundSx,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
